import { Col } from "reactstrap";
import big_logo from "../../assets/big-logo.png";
import InfoModal from "../modals/InfoModal";
export const AuthHalfScreenComp = ({ infoModal }) => {
  return (
    <Col
      md={6}
      lg={7}
      className="bg-primary-blue d-none d-md-flex position-relative d-flex flex-column align-items-center justify-content-center"
    >
      {infoModal && <InfoModal />}
      <img
        src={big_logo}
        height={441}
        className="full-width  object-fit-contain"
      />
    </Col>
  );
};
